import React from 'react';

const VendasContext = React.createContext();

export default VendasContext;